import React, { createContext, useState } from "react";
import App from "./App";
import { net } from "./database";
export const CenterContext = createContext();
export const StaffContext = createContext();
export const ClassesContext = createContext();
export const StudentsContext = createContext();
export const CustomersContext = createContext();
export const LanguageContext = createContext();
export const UserContext = createContext();
const l = require("./lang.json");


export default function Context(props) {
const [language, setLanguage] = useState(parseInt(localStorage.getItem("htx-language")) ?? 1);
React.useEffect(() => {
    localStorage.setItem("htx-language", language);
  }, [language]);
  const [user, setUser] = useState(undefined);
const [center, setCenter] = useState(undefined);
const [staffAll, setStaffAll] = useState([]);
const [classes, setClasses] = useState([]);
const [students, setStudents] = useState([]);
const [customers, setCustomers] = useState([]);
    
    React.useEffect(() => {
      try {
        if (user) {
          net.get("/context").then((res) => {
          
            setCenter((prev) => res.center);
            setStaffAll((prev) => res.staff);
            setClasses((prev) => res.classes);
            setStudents((prev) => res.students);
            setCustomers((prev) => res.customers);
          });
        }
      } catch (err) {
        console.error(err);
      }
    }, [user]);
   /*  if(!center ||!staffAll || !classes || !students || !customers) return <Loading/>; */
    return (
      <div>
        <LanguageContext.Provider value={{ l, language, setLanguage }}>
          <CenterContext.Provider
            value={{
              center,
              setCenter,
              getLocation: (id) => center.locations.find((l) => l._id === id),
              getLocationName: (id) =>
                center.locations.find((l) => l._id === id).name ||
                "No location",
              locations: center
                ? center.locations.filter((l) => l.name !== "All locations")
                : [],
              getAllLocations: () =>
                center.locations.find((l) => l.name === "All locations"),

              setSurveyTags: (surveyTags) =>
                setCenter((prev) => ({ ...prev, surveyTags })),
              getStoppedReason: (_id) => center.stoppedReasons.find(sr=>sr._id===_id)
            }}
          >
            <StaffContext.Provider
              value={{
                staff: staffAll.filter((s) => s.status === 0),
                staffAll,
                setStaffAll,
                findStaff: (_id) => staffAll.find((s) => s._id === _id),
                findStaffName: (_id) => {
                  let staff = staffAll.find((s) => s._id === _id);
                  if (staff && staff.name) return staff.name;
                  return "No name";
                },
                getStaffRole: (role) =>
                  staffAll.filter(
                    (s) => s.roles.includes(role) && s.status === 0
                  ),
                updateStaff: (_id, field, value) => {
                  setStaffAll((prev) =>
                    prev.map((p) =>
                      p._id !== _id ? p : { ...p, [field]: value }
                    )
                  );
                },
                update: (newStaff) => {
                  if (staffAll.find((s) => s._id === newStaff._id)) {
                    setStaffAll((prev) =>
                      prev.map((p) => (p._id !== newStaff._id ? p : newStaff))
                    );
                  } else {
                    setStaffAll((prev) => [...prev, newStaff]);
                  }
                },
                studentsITeach: (staffId) => {
                  const cls = classes.filter(c => c.teacher === staffId && c.status==="Active")
                  let myStudents = []
                  for (let c of cls) {
                    for (let s of c.students) {
                      let fstudent = students.find((st) => st._id === s);
                      console.log(fstudent)
                      if(fstudent) myStudents.push(fstudent)
                    }
                  }
                  return myStudents
                }
              }}
            >
              <ClassesContext.Provider
                value={{
                  classes,
                  setClasses,
                  findClass: (id) => classes.find((c) => c._id === id),
                  findClassName: (id) => {
                    let htClass = classes.find((c) => c._id === id);
                    if (htClass) return htClass.name;
                    return "Can't find this class";
                  },
                  findClasses: (arrayOfId) =>
                    classes.filter((c) => arrayOfId.includes(c._id)),
                  addClass: (cls) => setClasses((prev) => [...prev, cls]),
                  className: (id) => classes.find((c) => c._id === id).name,
                  activeClasses: () =>
                    classes.filter((c) =>
                      ["Active", "Coming"].includes(c.status)
                    ),
                  active: classes.filter((c) =>
                    ["Active", "Coming"].includes(c.status)
                  ),
                  classDays: (htClassId) => {
                    const htClass = classes.find((c) => c._id === htClassId);
                    if(!htClass) return [];
                    return htClass.classDays.map((c) => c.day);
                  },
                  teachersClasses: (staffId) =>
                    classes.filter((c) => c.teacher === staffId),
                  teachersClassesNames: (staffId) => classes.filter((c) => c.teacher === staffId).map(c => c.name),
                  todaysClasses : (location)=> location ? classes.filter(c=> ["Active","Tutoring"].includes(c.status) && c.location===location && c.classDays.map(cd=>cd.day).includes(new Date().getDay())) : []
                  
                }}
              >
                <StudentsContext.Provider
                  value={{
                    students,
                    setStudents,
                    activeStudents: students.filter((s) =>
                      ["New", "Active"].includes(s.status)
                    ),
                    studentsName: (id) =>
                      students.find((s) => s._id === id).name,
                    findStudent: (id) => students.find((s) => s._id === id),
                    addStudent: (cls) => setStudents((prev) => [...prev, cls]),
                    studentsByStatus: [
                      ...students.filter((s) =>
                        ["New", "Active"].includes(s.status)
                      ),
                      ...students.filter((s) => ["Pending"].includes(s.status)),
                      ...students.filter((s) =>
                        ["Lead", "Stopped"].includes(s.status)
                      ),
                      ...students.filter((s) => ["HotLead"].includes(s.status)),
                    ],
                  }}
                >
                  <CustomersContext.Provider
                    value={{
                      customers,
                      setCustomers,
                      findCustomer: (id) => customers.find((s) => s._id === id),
                      findCustomerByPhone: (phone) =>
                        customers.find(
                          (s) =>
                            s.phone === phone ||
                            (s.phone2 && s.phone2 === phone)
                        ),
                      addCustomer: (cls) =>
                        setCustomers((prev) => [...prev, cls]),
                    }}
                  >
                    <UserContext.Provider
                      value={{
                        user,
                        setUser,
                        checkRoles: (roles) => { 
                          if (typeof roles === "string") return user.roles.includes(roles)
                          for(const r of roles){
                            if(user.roles.includes(r)) return true
                          }
                          return false
                        }
                      }}
                    >
                      <App
                        user={user}
                        setUser={setUser}
                        language={language}
                        setLanguage={setLanguage}
                        center={center}
                        setCenter={setCenter}
                        staffAll={staffAll}
                        l={l}
                      />{" "}
                    </UserContext.Provider>
                  </CustomersContext.Provider>
                </StudentsContext.Provider>
              </ClassesContext.Provider>
            </StaffContext.Provider>
          </CenterContext.Provider>
        </LanguageContext.Provider>
      </div>
    );
}